// ═══════════════════════════════════════════════════════════════
// Paso 1: Descargar plantilla Excel
// ═══════════════════════════════════════════════════════════════

import React from 'react';
import { Download, FileSpreadsheet, CheckCircle2, AlertCircle } from 'lucide-react';

const Step1_Download = ({ onDownload, onNext, loading, error }) => {
  return (
    <div className="space-y-6">
      <div className="text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-4">
          <FileSpreadsheet className="w-8 h-8 text-green-600" />
        </div>
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          Descarga la plantilla Excel
        </h3>
        <p className="text-sm text-gray-500 max-w-md mx-auto">
          La plantilla incluye todos los campos necesarios y las listas de departamentos
          y cargos disponibles en tu empresa para facilitar el llenado.
        </p>
      </div>

      {/* Instrucciones */}
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 space-y-3">
        <p className="text-sm font-medium text-blue-900">Instrucciones:</p>
        <ul className="space-y-1.5">
          {[
            'Descarga la plantilla y ábrela en Excel o Google Sheets.',
            'Llena los datos de cada empleado en una fila.',
            'Los campos marcados con * son obligatorios.',
            'Usa exactamente los valores de las listas desplegables para Departamento y Cargo.',
            'No elimines ni cambies las columnas de cabecera.',
            'Guarda el archivo en formato .xlsx antes de subirlo.',
          ].map((txt, i) => (
            <li key={i} className="flex items-start gap-2 text-sm text-blue-800">
              <CheckCircle2 className="w-4 h-4 text-blue-500 mt-0.5 flex-shrink-0" />
              {txt}
            </li>
          ))}
        </ul>
      </div>

      {/* Campos de la plantilla */}
      <div className="grid grid-cols-2 gap-2">
        {[
          { campo: 'Nombre *', desc: 'Primer nombre del empleado' },
          { campo: 'Apellido *', desc: 'Primer apellido' },
          { campo: 'Cédula *', desc: 'Número de identidad único' },
          { campo: 'Fecha Nacimiento', desc: 'DD/MM/YYYY' },
          { campo: 'Sexo', desc: 'M o F' },
          { campo: 'Email', desc: 'Correo electrónico' },
          { campo: 'Teléfono', desc: 'Número de contacto' },
          { campo: 'Dirección', desc: 'Dirección completa' },
          { campo: 'Departamento', desc: 'De la lista disponible' },
          { campo: 'Cargo', desc: 'De la lista disponible' },
          { campo: 'Fecha Ingreso', desc: 'DD/MM/YYYY' },
          { campo: 'Salario', desc: 'Monto numérico (ej: 25000)' },
        ].map(({ campo, desc }) => (
          <div key={campo} className="bg-gray-50 rounded px-3 py-2">
            <span className="text-xs font-medium text-gray-800">{campo}</span>
            <p className="text-xs text-gray-500">{desc}</p>
          </div>
        ))}
      </div>

      {error && (
        <div className="flex items-center gap-2 p-3 bg-red-50 border border-red-200 rounded-lg text-sm text-red-700">
          <AlertCircle className="w-4 h-4 flex-shrink-0" />
          {error}
        </div>
      )}

      <div className="flex justify-between pt-2">
        <button
          onClick={onDownload}
          disabled={loading}
          className="inline-flex items-center gap-2 px-5 py-2.5 bg-green-600 text-white text-sm font-medium rounded-lg hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          <Download className="w-4 h-4" />
          {loading ? 'Descargando...' : 'Descargar Plantilla'}
        </button>

        <button
          onClick={onNext}
          className="inline-flex items-center gap-2 px-5 py-2.5 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition-colors"
        >
          Ya tengo la plantilla, continuar →
        </button>
      </div>
    </div>
  );
};

export default Step1_Download;
